import React, { Component } from "react";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";

class Terms extends Component {
    body() {
        return (
            <div className='container'>
                <h1>
                    <strong>MASHIE App Privacy Policy</strong>
                </h1>
                <h2>
                    <strong>INTRODUCTION</strong>
                </h2>
                <p>
                    Welcome to Coinbridge Ltd's trading as MASHIE privacy
                    notice.
                </p>
                <p>
                    MASHIE respects your privacy and is committed to protecting
                    your personal data. This privacy notice will inform you as
                    to how we look after your personal data when you download
                    and use our mobile application (regardless of where you
                    access it from) and tell you about your privacy rights and
                    how the law protects you.
                </p>
                <p>
                    This privacy notice is provided in a layered format so you
                    can click through to the specific areas set out below.
                    Please also use the Glossary to understand the meaning of
                    some of the terms used in this privacy notice.
                </p>
                <ol>
                    <li>
                        <strong>
                            <em>IMPORTANT INFORMATION AND WHO WE ARE</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>THE DATA WE COLLECT ABOUT YOU</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>HOW IS YOUR PERSONAL DATA COLLECTED</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>HOW WE USE YOUR PERSONAL DATA</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>DISCLOSURES OF YOUR PERSONAL DATA</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>INTERNATIONAL TRANSFERS</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>DATA SECURITY</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>DATA RETENTION</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>YOUR LEGAL RIGHTS</em>
                        </strong>
                    </li>
                    <li>
                        <strong>
                            <em>GLOSSARY</em>
                        </strong>
                    </li>
                </ol>
                <ol>
                    <li>
                        <strong>IMPORTANT INFORMATION AND WHO WE ARE</strong>
                    </li>
                </ol>
                <p>
                    <strong>PURPOSE OF THIS PRIVACY NOTICE</strong>
                </p>
                <p>
                    This privacy notice aims to give you information on how
                    MASHIE collects and processes your personal data through
                    your use of this application, including any data you may
                    provide through this mobile application when you sign up to
                    use our reminder service, vehicle statistics data, marketing
                    and related communications.{" "}
                </p>
                <p>
                    This mobile application is not intended for children and we
                    do not knowingly collect data relating to children.
                </p>
                <p>
                    It is important that you read this privacy notice together
                    with any other privacy notice or fair processing notice we
                    may provide on specific occasions when we are collecting or
                    processing personal data about you so that you are fully
                    aware of how and why we are using your data. This privacy
                    notice supplements the other notices and is not intended to
                    override them.
                </p>
                <p>
                    <strong>CONTROLLER</strong>{" "}
                </p>
                <p>
                    Coinbridge Ltd and your registered company are the joint
                    controllers and responsible for your personal data
                    (collectively referred to as &ldquo;we&rdquo;,
                    &ldquo;us&rdquo; or &ldquo;our&rdquo; in this privacy
                    notice).MASHIE are responsible for the business purpose of
                    the data processing as well as the method of data
                    processing.{" "}
                </p>
                <p>
                    If you have any questions about this privacy notice,
                    including any requests to exercise your legal rights, please
                    contact us using the details set out below.{" "}
                </p>
                <p>
                    <strong>CONTACT DETAILS</strong>{" "}
                </p>
                <p>
                    Our full details are: Our full details are: Coinbridge
                    Limited trading as MASHIE, at 1-3 The Apple Store, Far Peak,
                    Northleach, Gloucestershire, United Kingdom, GL54 3JL
                </p>
                <p>Full name of legal entity: Coinbridge Limited</p>
                <p>
                    Data Protection Email address:{" "}
                    <a href='mailto:data.protection@mashiegolf.co.uk'>
                        data.protection@mashiegolf.co.uk
                    </a>
                </p>
                <p>
                    Postal address: FAO Data Protection, Coinbridge Ltd, 1-3 The
                    Apple Store, Far Peak, Northleach, Gloucestershire, United
                    Kingdom, GL54 3JL
                </p>
                <p>
                    You have the right to make a complaint at any time to the
                    Information Commissioner&rsquo;s Office (ICO), the UK
                    supervisory authority for data protection issues (
                    <em>
                        <a href='http://www.ico.org.uk/'>www.ico.org.uk</a>
                    </em>
                    ). We would, however, appreciate the chance to deal with
                    your concerns before you approach the ICO so please contact
                    us in the first instance.
                </p>
                <p>
                    <strong>
                        CHANGES TO THE PRIVACY NOTICE AND YOUR DUTY TO INFORM US
                        OF CHANGES
                    </strong>{" "}
                </p>
                <p>
                    This version was last updated on 14th May 2021 and historic
                    versions can be obtained by contacting our customer services
                    on the mashiegolf.co.uk website.
                </p>
                <p>The data protection law in the UK changed on 25 May 2018.</p>
                <p>
                    It is important that the personal data we hold about you is
                    accurate and current. Please keep us informed if your
                    personal data changes during your relationship with us.
                </p>
                <p>
                    <strong>THIRD-PARTY LINKS</strong>
                </p>
                <p>
                    This mobile application includes links to third-party
                    websites, plug-ins and applications. Clicking on those links
                    or enabling those connections may allow third parties to
                    collect or share data about you. We do not control these
                    third-party websites and are not responsible for their
                    privacy statements. When you leave our mobile application,
                    we encourage you to read the privacy notice of every website
                    you visit.
                </p>
                <ol start='2'>
                    <li>
                        <strong>THE DATA WE COLLECT ABOUT YOU</strong>
                    </li>
                </ol>
                <p>
                    Personal data, or personal information, means any
                    information about an individual from which that person can
                    be identified. It does not include data where the identity
                    has been removed (anonymous data).
                </p>
                <p>
                    We may collect, use, store and transfer different kinds of
                    personal data about you which we have grouped together
                    follows:
                </p>
                <ul>
                    <li>
                        <strong>Identity Data </strong>includes first name, last
                        name, gender and date of birth.
                    </li>
                    <li>
                        <strong>Contact Data </strong>Email, Phone Number &
                        Address
                    </li>
                    <li>
                        <strong>Transaction Data </strong>includes details of
                        the reminder and marketing services you used on The App.
                    </li>
                    <li>
                        <strong>Technical Data </strong>includes internet
                        protocol (IP) address, your login data, browser type and
                        version, time zone setting and location, browser plug-in
                        types and versions, operating system and platform and
                        other technology on the devices you use to access this
                        mobile application.
                    </li>
                    <li>
                        <strong>Profile Data </strong>includesyour password,
                        reminder and marketing services used.
                    </li>
                    <li>
                        <strong>Usage Data </strong>includes information about
                        how you use our mobile application, products and
                        services.
                    </li>
                    <li>
                        <strong>Marketing and Communications Data </strong>
                        includes your preferences in receiving marketing from us
                        and our third parties and your communication
                        preferences.
                    </li>
                </ul>
                <p>
                    We also collect, use and share{" "}
                    <strong>Aggregated Data </strong>such as statistical or
                    demographic data for any purpose. Aggregated Data may be
                    derived from your personal data but is not considered
                    personal data in law as this data does <strong>not </strong>
                    directly or indirectly reveal your identity. For example, we
                    may aggregate your Usage Data to calculate the percentage of
                    users accessing a specific mobile application feature.
                    However, if we combine or connect Aggregated Data with your
                    personal data so that it can directly or indirectly identify
                    you, we treat the combined data as personal data which will
                    be used in accordance with this privacy notice.
                </p>
                <p>
                    We do not collect any{" "}
                    <strong>Special Categories of Personal Data </strong>about
                    you (this includes details about your race or ethnicity,
                    religious or philosophical beliefs, sex life, sexual
                    orientation, political opinions, trade union membership,
                    information about your health and genetic and biometric
                    data). Nor do we collect any information about criminal
                    convictions and offences.
                </p>
                <p>
                    <strong>IF YOU FAIL TO PROVIDE PERSONAL DATA</strong>
                </p>
                <p>
                    Where we need to collect personal data by law, or under the
                    terms of a contract we have with you and you fail to provide
                    that data when requested, we may not be able to perform the
                    contract we have or are trying to enter into with you (for
                    example, to provide you reminder services). In this case, we
                    may have to cancel a service you have with us but we will
                    notify you if this is the case at the time.
                </p>
                <ol start='3'>
                    <li>
                        <strong>HOW IS YOUR PERSONAL DATA COLLECTED?</strong>
                    </li>
                </ol>
                <p>
                    We use different methods to collect data from and about you
                    including through:
                </p>
                <ul>
                    <li>
                        <strong>Direct interactions. </strong>You may give us
                        your Identity and Contact Data by filling in forms or by
                        corresponding with us by post, phone, email or
                        otherwise. This includes personal data you provide when
                        you:
                        <ul>
                            <li>Downloaded the mobile application;</li>
                            <li>
                                Register for an account on the mobile
                                application;
                            </li>
                            <li>
                                Request marketing (motoring related news, offers
                                and messages) to be sent to you;
                            </li>
                        </ul>
                    </li>
                    <li>
                        <strong>
                            Automated technologies or interactions.{" "}
                        </strong>
                        As you interact with our mobile application, we may
                        automatically collect Technical Data about your
                        equipment, browsing actions and patterns. We collect
                        this personal data by using cookies, server logs and
                        other similar technologies. We may also receive
                        Technical Data about you if you visit other MASHIE
                        websites employing our cookies. Please see our separate
                        cookie policy[INSERT LINK]for further details.
                    </li>
                    <li>
                        <strong>
                            Third parties or publicly available sources.{" "}
                        </strong>
                        We may receive personal data about you from various
                        third parties and public sources as set out below:
                        <ul>
                            <li>
                                Technical Data from the following parties:
                                <br />
                                Analytics providers: such as Google based
                                outside the EU;
                            </li>
                            <li>
                                Identity Data from publicly availably sources
                                such as DVLA based inside the EU.
                            </li>
                        </ul>
                    </li>
                </ul>
                <ol start='4'>
                    <li>
                        <strong>HOW WE USE YOUR PERSONAL DATA</strong>
                    </li>
                </ol>
                <p>
                    We will only use your personal data when the law allows us
                    to. Most commonly, we will use your personal data in the
                    following circumstances:
                </p>
                <ul>
                    <li>
                        Where we need to perform the contract we are about to
                        enter into or have entered into with you.
                    </li>
                    <li>
                        Where it is necessary for our legitimate interests (or
                        those of a third party) and your interests and
                        fundamental rights do not override those interests.
                    </li>
                    <li>
                        Where we need to comply with a legal or regulatory
                        obligation.
                    </li>
                </ul>
                <p>
                    Click <em>here </em>to find out more about the types of
                    lawful basis that we will rely on to process your personal
                    data.
                </p>
                <p>
                    Generally we do not rely on consent as a legal basis for
                    processing your personal data other than in relation to
                    sending third party direct marketing communications to you
                    via push notification, text message or email. You have the
                    right to withdraw consent to marketing at any time by
                    updating your preferences in Settings on the mobile
                    application or emailing us at{" "}
                    <a href='mailto:data.protection@mashiegolf.co.uk'>
                        data.protection@mashiegolf.co.uk
                    </a>{" "}
                    to delete your account.
                </p>
                <p>
                    <strong>
                        PURPOSES FOR WHICH WE WILL USE YOUR PERSONAL DATA
                    </strong>{" "}
                </p>
                <p>
                    We have set out below, in a table format, a description of
                    all the ways we plan to use your personal data, and which of
                    the legal bases we rely on to do so. We have also identified
                    what our legitimate interests are where appropriate.{" "}
                </p>
                <p>
                    Note that we may process your personal data for more than
                    one lawful ground depending on the specific purpose for
                    which we are using your data. Please contact customer
                    services at mashiegolf.co.uk if you need details about the
                    specific legal ground we are relying on to process your
                    personal data where more than one ground has been set out in
                    the table below.
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td width='227'>
                                <p>
                                    <strong>Purpose/Activity</strong>
                                </p>
                            </td>
                            <td width='172'>
                                <p>
                                    <strong>Type of data</strong>
                                </p>
                            </td>
                            <td width='275'>
                                <p>
                                    <strong>
                                        Lawful basis for processing including
                                        basis of legitimate interest
                                    </strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>To register you as a new customer</p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                            </td>
                            <td width='275'>
                                <p>Performance of a contract with you</p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To process and deliver your order including:
                                </p>
                                <p>Providing reminder notifications</p>
                                <p>
                                    Providing MOT and car service quotation and
                                    booking services
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                                <p>(c) Transaction</p>
                                <p>(d) Marketing and Communications</p>
                            </td>
                            <td width='275'>
                                <p>Performance of a contract with you</p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To manage our relationship with you which
                                    will include:
                                </p>
                                <p>
                                    Notifying you about changes to our terms or
                                    privacy policy
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                                <p>(c) Profile</p>
                                <p>(d) Marketing and Communications </p>
                            </td>
                            <td width='275'>
                                <p>(a) Performance of a contract with you</p>
                                <p>
                                    (b) Necessary to comply with a legal
                                    obligation
                                </p>
                                <p>
                                    (c) Necessary for our legitimate interests
                                    (to keep our records updated and to study
                                    how customers use our products/services)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To administer and protect our business and
                                    this mobile application (including
                                    troubleshooting, data analysis, testing,
                                    system maintenance, support, reporting and
                                    hosting of data)
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                                <p>(c) Technical</p>
                            </td>
                            <td width='275'>
                                <p>
                                    (a) Necessary for our legitimate interests
                                    (for running our business, provision of
                                    administration and IT services, network
                                    security, to prevent fraud and in the
                                    context of a business reorganisation or
                                    group restructuring exercise)
                                </p>
                                <p>
                                    (b) Necessary to comply with a legal
                                    obligation
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To deliver relevant mobile application
                                    content and advertisements to you and
                                    measure or understand the effectiveness of
                                    the advertising we serve to you
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                                <p>(c) Profile</p>
                                <p>(d) Usage</p>
                                <p>(e) Marketing and Communications</p>
                                <p>(f) Technical </p>
                            </td>
                            <td width='275'>
                                <p>
                                    Necessary for our legitimate interests (to
                                    study how customers use our
                                    products/services, to develop them, to grow
                                    our business and to inform our marketing
                                    strategy)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To use data analytics to improve our mobile
                                    application, products/services, marketing,
                                    customer relationships and experiences
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Technical</p>
                                <p>(b) Usage</p>
                            </td>
                            <td width='275'>
                                <p>
                                    Necessary for our legitimate interests (to
                                    define types of customers for our products
                                    and services, to keep our mobile application
                                    updated and relevant, to develop our
                                    business and to inform our marketing
                                    strategy)
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width='227'>
                                <p>
                                    To make suggestions and recommendations to
                                    you about goods or services that may be of
                                    interest to you
                                </p>
                            </td>
                            <td width='172'>
                                <p>(a) Identity</p>
                                <p>(b) Contact</p>
                                <p>(c) Technical</p>
                                <p>(d) Usage</p>
                                <p>(e) Profile</p>
                            </td>
                            <td width='275'>
                                <p>
                                    Necessary for our legitimate interests (to
                                    develop our products/services and grow our
                                    business)
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <strong>MARKETING</strong>{" "}
                </p>
                <p>
                    We strive to provide you with choices regarding certain
                    personal data uses, particularly around marketing and
                    advertising. We have established the following personal data
                    control mechanisms:
                </p>
                <p>
                    - Your account can be deleted at anytime by emailing{" "}
                    <a href='mailto:data.protection@mashiegolf.co.uk'>
                        data.protection@mashiegolf.co.uk
                    </a>
                    .
                </p>
                <p>
                    <strong>PROMOTIONAL OFFERS FROM US</strong>{" "}
                </p>
                <p>
                    We may use your Identity, Contact, Technical, Usage and
                    Profile Data to form a view on what we think you may want or
                    need, or what may be of interest to you. This is how we
                    decide which products, services and offers may be relevant
                    for you (we call this marketing).
                </p>
                <p>
                    You will receive marketing communications from us if you
                    have elected to on the mobile application.
                </p>
                <p>
                    <strong>
                        PROMOTIONAL OFFERS FROM your registered company
                    </strong>{" "}
                </p>
                <p>
                    Your registered company may use your Identity, Contact,
                    Technical, Usage and Profile Data to form a view on what
                    they think you may want or need, or what may be of interest
                    to you. This is how they decide which products, services and
                    offers may be relevant for you (they call this marketing).
                </p>
                <p>
                    You will receive marketing communications from your
                    registered company if you have elected to on the mobile
                    application.
                </p>
                <p>
                    <strong>THIRD-PARTY MARKETING</strong>
                </p>
                <p>
                    We will get your express opt-in consent before we share your
                    personal data with any company outside the MASHIE GROUP OF
                    COMPANIES for marketing purposes.
                </p>
                <p>
                    <strong>OPTING OUT</strong>
                </p>
                <p>
                    - Your account can be deleted at anytime by emailing{" "}
                    <a href='mailto:data.protection@mashiegolf.co.uk'>
                        data.protection@mashiegolf.co.uk
                    </a>
                    .
                </p>
                <p>
                    <strong>COOKIES</strong>
                </p>
                <p>
                    You can set your browser to refuse all or some browser
                    cookies, or to alert you when mobile applications set or
                    access cookies. If you disable or refuse cookies, please
                    note that some parts of this mobile application may become
                    inaccessible or not function properly.
                </p>
                <p>
                    <strong>CHANGE OF PURPOSE</strong>
                </p>
                <p>
                    We will only use your personal data for the purposes for
                    which we collected it, unless we reasonably consider that we
                    need to use it for another reason and that reason is
                    compatible with the original purpose. If you wish to get an
                    explanation as to how the processing for the new purpose is
                    compatible with the original purpose, pleasecontact our
                    customer services via our website,{" "}
                    <a href='http://www.MASHIE.co.uk'>www.MASHIE.co.uk</a>.
                </p>
                <p>
                    If we need to use your personal data for an unrelated
                    purpose, we will notify you and we will explain the legal
                    basis which allows us to do so.
                </p>
                <p>
                    Please note that we may process your personal data without
                    your knowledge or consent, in compliance with the above
                    rules, where this is required or permitted by law.
                </p>
                <ol start='5'>
                    <li>
                        <strong>DISCLOSURES OF YOUR PERSONAL DATA</strong>
                    </li>
                </ol>
                <p>
                    We may have to share your personal data with the parties set
                    out below for the purposes set out in the table in paragraph
                    4 above.
                </p>
                <ul>
                    <li>
                        Internal Third Parties as set out in the{" "}
                        <em>Glossary</em>.
                    </li>
                    <li>
                        External Third Parties as set out in the{" "}
                        <em>Glossary</em>.
                    </li>
                </ul>
                <table>
                    <tbody>
                        <tr>
                            <td width='284'>
                                <p>Digital Ocean</p>
                            </td>
                            <td width='284'>
                                <p>Hosting Mobile Application service</p>
                            </td>
                        </tr>
                        <tr>
                            <td width='284'>
                                <p>Mailgun</p>
                            </td>
                            <td width='284'>
                                <p>Send agreed email communications</p>
                            </td>
                        </tr>
                        <tr>
                            <td width='284'>
                                <p>Google Firebase</p>
                            </td>
                            <td width='284'>
                                <p>Send agreed push communications</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <ul>
                    <li>
                        Third parties to whom we may choose to sell, transfer,
                        or merge parts of our business or our assets.
                        Alternatively, we may seek to acquire other businesses
                        or merge with them. If a change happens to our business,
                        then the new owners may use your personal data in the
                        same way as set out in this privacy notice.
                    </li>
                </ul>
                <p>
                    We require all third parties to respect the security of your
                    personal data and to treat it in accordance with the law. We
                    do not allow our third-party service providers to use your
                    personal data for their own purposes and only permit them to
                    process your personal data for specified purposes and in
                    accordance with our instructions.
                </p>
                <ol start='6'>
                    <li>
                        <strong>INTERNATIONAL TRANSFERS</strong>{" "}
                    </li>
                </ol>
                <p>
                    We share your personal data within the Coinbridge Ltd group,
                    your registered company and specified third parties. This
                    will not involve transferring your data outside the European
                    Economic Area (<strong>EEA</strong>).{" "}
                </p>
                <ol start='7'>
                    <li>
                        <strong>DATA SECURITY</strong>
                    </li>
                </ol>
                <p>
                    We have put in place appropriate security measures to
                    prevent your personal data from being accidentally lost,
                    used or accessed in an unauthorised way, altered or
                    disclosed. In addition, we limit access to your personal
                    data to those employees, agents, contractors and other third
                    parties who have a business need to know. They will only
                    process your personal data on our instructions and they are
                    subject to a duty of confidentiality.
                </p>
                <p>
                    We have put in place procedures to deal with any suspected
                    personal data breach and will notify you and any applicable
                    regulator of a breach where we are legally required to do
                    so.
                </p>
                <ol start='8'>
                    <li>
                        <strong>DATA RETENTION</strong>
                    </li>
                </ol>
                <p>
                    <strong>HOW LONG WILL YOU USE MY PERSONAL DATA FOR?</strong>{" "}
                </p>
                <p>
                    We will only retain your personal data for as long as
                    necessary to fulfil the purposes we collected it for,
                    including for the purposes of satisfying any legal,
                    accounting, or reporting requirements.{" "}
                </p>
                <p>
                    To determine the appropriate retention period for personal
                    data, we consider the amount, nature, and sensitivity of the
                    personal data, the potential risk of harm from unauthorised
                    use or disclosure of your personal data, the purposes for
                    which we process your personal data and whether we can
                    achieve those purposes through other means, and the
                    applicable legal requirements.
                </p>
                <p>
                    Details of retention periods for different aspects of your
                    personal data are available in our retention policy which
                    you can request from us by contacting our customer services
                    team via our website, MASHIE.co.uk.
                </p>
                <p>
                    By law we have to keep basic information about our customers
                    (including Transaction Data) for six years after they cease
                    being customers for tax purposes.
                </p>
                <p>
                    In some circumstances you can ask us to delete your data:
                    see <em>Request erasure</em>below for further information.
                </p>
                <p>
                    In some circumstances we may anonymise your personal data
                    (so that it can no longer be associated with you) for
                    research or statistical purposes in which case we may use
                    this information indefinitely without further notice to you.
                </p>
                <ol start='9'>
                    <li>
                        <strong>YOUR LEGAL RIGHTS</strong>
                    </li>
                </ol>
                <p>
                    Under certain circumstances, you have rights under data
                    protection laws in relation to your personal data. Please
                    click on the links below to find out more about these
                    rights:
                </p>
                <ul>
                    <li>
                        [<em>Request access to your personal data</em>].
                    </li>
                    <li>
                        [<em>Request correction of your personal data</em>].
                    </li>
                    <li>
                        [<em>Request erasure of your personal data</em>].
                    </li>
                    <li>
                        [<em>Object to processing of your personal data</em>].
                    </li>
                    <li>
                        [
                        <em>
                            Request restriction of processing your personal data
                        </em>
                        ].
                    </li>
                    <li>
                        [<em>Request transfer of your personal data</em>].
                    </li>
                    <li>
                        [<em>Right to withdraw consent</em>].
                    </li>
                </ul>
                <p>
                    If you wish to exercise any of the rights set out above,
                    please contact our customer services team via our website,
                    MASHIE.co.uk.
                </p>
                <p>
                    <strong>NO FEE USUALLY REQUIRED</strong>{" "}
                </p>
                <p>
                    You will not have to pay a fee to access your personal data
                    (or to exercise any of the other rights). However, we may
                    charge a reasonable fee if your request is clearly
                    unfounded, repetitive or excessive. Alternatively, we may
                    refuse to comply with your request in these circumstances.{" "}
                </p>
                <p>
                    <strong>WHAT WE MAY NEED FROM YOU</strong>
                </p>
                <p>
                    We may need to request specific information from you to help
                    us confirm your identity and ensure your right to access
                    your personal data (or to exercise any of your other
                    rights). This is a security measure to ensure that personal
                    data is not disclosed to any person who has no right to
                    receive it. We may also contact you to ask you for further
                    information in relation to your request to speed up our
                    response.{" "}
                </p>
                <p>
                    <strong>TIME LIMIT TO RESPOND</strong>{" "}
                </p>
                <p>
                    We try to respond to all legitimate requests within one
                    month. Occasionally it may take us longer than a month if
                    your request is particularly complex or you have made a
                    number of requests. In this case, we will notify you and
                    keep you updated.{" "}
                </p>
                <ol start='10'>
                    <li>
                        <strong>GLOSSARY</strong>
                    </li>
                </ol>
                <p>
                    <strong>LAWFUL BASIS</strong>{" "}
                </p>
                <p>
                    <strong>Legitimate Interest </strong>means the interest of
                    our business in conducting and managing our business to
                    enable us to give you the best service/product and the best
                    and most secure experience. We make sure we consider and
                    balance any potential impact on you (both positive and
                    negative) and your rights before we process your personal
                    data for our legitimate interests. We do not use your
                    personal data for activities where our interests are
                    overridden by the impact on you (unless we have your consent
                    or are otherwise required or permitted to by law). You can
                    obtain further information about how we assess our
                    legitimate interests against any potential impact on you in
                    respect of specific activities by contact our customer
                    services team via our website, MASHIE.co.uk.
                </p>
                <p>
                    <strong>Performance of Contract </strong>means processing
                    your data where it is necessary for the performance of a
                    contract to which you are a party or to take steps at your
                    request before entering into such a contract.{" "}
                </p>
                <p>
                    <strong>
                        Comply with a legal or regulatory obligation{" "}
                    </strong>
                    means processing your personal data where it is necessary
                    for compliance with a legal or regulatory obligation that we
                    are subject to.
                </p>
                <p>
                    <strong>Data Controller </strong>means a person who (either
                    alone or jointly or in common with other persons) determines
                    the purposes for which and the manner in which any personal
                    data are, or are to be, processed.{" "}
                </p>
                <p>
                    <strong>Personal Data </strong>means any information
                    relating to an identifiable person who can be directly or
                    indirectly identified in particular by reference to an
                    identifier.
                </p>
                <p>
                    <strong>Processing</strong>, in relation to information or
                    data, means obtaining, recording or holding the information
                    or data or carrying out any operation or set of operations
                    on the information or data, including &ndash;
                </p>
                <p>
                    (a) organisation, adaptation or alteration of the
                    information or data,
                </p>
                <p>
                    (b) retrieval, consultation or use of the information or
                    data,
                </p>
                <p>
                    (c) disclosure of the information or data by transmission,
                    dissemination or otherwise making available, or
                </p>
                <p>
                    (d) alignment, combination, blocking, erasure or destruction
                    of the information or data.
                </p>
                <p>
                    <strong>Special Category Data </strong>is broadly similar to
                    the concept of sensitive personal data under the 1998 Data
                    Protection Act. The requirement to identify a specific
                    condition for processing this type of data is also very
                    similar.This is because special category data is more
                    sensitive, and so needs more protection.For example, Special
                    Category Data is information about an individual&rsquo;s:
                    race; ethnic origin; politics; religion; trade union
                    membership; genetics; biometrics (where used for ID
                    purposes); health; sex life; or sexual orientation.
                </p>
                <p>
                    <strong>THIRD PARTIES</strong>{" "}
                </p>
                <p>
                    <strong>INTERNAL THIRD PARTIES</strong>{" "}
                </p>
                <p>
                    Other companies in the Coinbridge Ltd Group acting as
                    processors and who are based in the United Kingdom and
                    provide IT and system administration services and undertake
                    leadership reporting.
                </p>
                <p>
                    <strong>EXTERNAL THIRD PARTIES</strong>{" "}
                </p>
                <ul>
                    <li>
                        Service providers acting as a joint controller and
                        processors based in the United Kingdom who provide IT
                        and system administration services.
                    </li>
                    <li>
                        Professional advisers acting as processors including
                        lawyers, bankers, auditors and insurers based in the
                        United Kingdom who provide consultancy, banking, legal,
                        insurance and accounting services.
                    </li>
                    <li>
                        HM Revenue &amp; Customs, regulators and other
                        authorities acting as processors based in the United
                        Kingdom who require reporting of processing activities
                        in certain circumstances.
                    </li>
                </ul>
                <p>
                    <strong>YOUR LEGAL RIGHTS</strong>{" "}
                </p>
                <p>You have the right to:</p>
                <p>
                    <strong>Request access </strong>to your personal data
                    (commonly known as a &ldquo;data subject access
                    request&rdquo;). This enables you to receive a copy of the
                    personal data we hold about you and to check that we are
                    lawfully processing it.{" "}
                </p>
                <p>
                    <strong>Request correction </strong>of the personal data
                    that we hold about you. This enables you to have any
                    incomplete or inaccurate data we hold about you corrected,
                    though we may need to verify the accuracy of the new data
                    you provide to us.
                </p>
                <p>
                    <strong>Request erasure </strong>of your personal data. This
                    enables you to ask us to delete or remove personal data
                    where there is no good reason for us continuing to process
                    it. You also have the right to ask us to delete or remove
                    your personal data where you have successfully exercised
                    your right to object to processing (see below), where we may
                    have processed your information unlawfully or where we are
                    required to erase your personal data to comply with local
                    law. Note, however, that we may not always be able to comply
                    with your request of erasure for specific legal reasons
                    which will be notified to you, if applicable, at the time of
                    your request.
                </p>
                <p>
                    <strong>Object to processing </strong>of your personal data
                    where we are relying on a legitimate interest (or those of a
                    third party) and there is something about your particular
                    situation which makes you want to object to processing on
                    this ground as you feel it impacts on your fundamental
                    rights and freedoms. You also have the right to object where
                    we are processing your personal data for direct marketing
                    purposes. In some cases, we may demonstrate that we have
                    compelling legitimate grounds to process your information
                    which override your rights and freedoms.{" "}
                </p>
                <p>
                    <strong>Request restriction of processing </strong>of your
                    personal data. This enables you to ask us to suspend the
                    processing of your personal data in the following scenarios:
                    (a) if you want us to establish the data&rsquo;s accuracy;
                    (b) where our use of the data is unlawful but you do not
                    want us to erase it; (c) where you need us to hold the data
                    even if we no longer require it as you need it to establish,
                    exercise or defend legal claims; or (d) you have objected to
                    our use of your data but we need to verify whether we have
                    overriding legitimate grounds to use it.
                </p>
                <p>
                    {" "}
                    <strong>Request the transfer </strong>of your personal data
                    to you or to a third party. We will provide to you, or a
                    third party you have chosen, your personal data in a
                    structured, commonly used, machine-readable format. Note
                    that this right only applies to automated information which
                    you initially provided consent for us to use or where we
                    used the information to perform a contract with you.
                </p>
                <p>
                    <strong>Withdraw consent at any time </strong>where we are
                    relying on consent to process your personal data. However,
                    this will not affect the lawfulness of any processing
                    carried out before you withdraw your consent. If you
                    withdraw your consent, we may not be able to provide certain
                    products or services to you. We will advise you if this is
                    the case at the time you withdraw your consent.
                </p>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>{this.body()}</div>
                <Footer />
            </>
        );
    }
}

export default Terms;
